const EmptySmall = props => {
  const { style, ...rest } = props
  return (
    <div
      {...rest}
      style={{
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        ...style,
      }}
    >
      <svg
        width="160"
        height="161"
        viewBox="0 0 160 161"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_766_23089)">
          <g filter="url(#filter0_f_766_23089)">
            <path
              d="M79.1143 110.147C103.541 110.147 123.343 90.9155 123.343 67.1924C123.343 43.4693 103.541 24.2379 79.1143 24.2379C54.6875 24.2379 34.8857 43.4693 34.8857 67.1924C34.8857 90.9155 54.6875 110.147 79.1143 110.147Z"
              fill="#C1CBFF"
            />
          </g>
          <path
            d="M79.1144 116.363C107.076 116.363 129.743 94.3483 129.743 67.1924C129.743 40.0364 107.076 18.0222 79.1144 18.0222C51.153 18.0222 28.4858 40.0364 28.4858 67.1924C28.4858 94.3483 51.153 116.363 79.1144 116.363Z"
            fill="#EFF2FF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M79.1144 116.363C107.076 116.363 129.743 94.3483 129.743 67.1924C129.743 40.0364 107.076 18.0222 79.1144 18.0222C51.153 18.0222 28.4858 40.0364 28.4858 67.1924C28.4858 94.3483 51.153 116.363 79.1144 116.363ZM79.1144 20.686C105.561 20.686 127 41.5076 127 67.1924C127 92.8772 105.561 113.699 79.1144 113.699C52.6678 113.699 31.2287 92.8772 31.2287 67.1924C31.2287 41.5076 52.6678 20.686 79.1144 20.686Z"
            fill="white"
          />
          <mask
            id="mask0_766_23089"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="31"
            y="20"
            width="96"
            height="94"
          >
            <path
              d="M79.1142 113.477C105.434 113.477 126.771 92.7545 126.771 67.1924C126.771 41.6302 105.434 20.908 79.1142 20.908C52.7939 20.908 31.457 41.6302 31.457 67.1924C31.457 92.7545 52.7939 113.477 79.1142 113.477Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_766_23089)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M73.4251 49.9306H70.7451C67.73 49.9306 65.2856 52.3046 65.2856 55.2328C65.2856 58.1611 67.73 60.535 70.7451 60.535H87.0262C90.0413 60.535 92.4856 58.1611 92.4856 55.2328C92.4856 52.3046 90.0413 49.9306 87.0262 49.9306H84.3439V47.521C84.3439 44.5927 81.8996 42.2188 78.8845 42.2188C75.8694 42.2188 73.4251 44.5927 73.4251 47.521V49.9306Z"
              fill="url(#paint0_linear_766_23089)"
            />
          </g>
          <mask
            id="mask1_766_23089"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="31"
            y="20"
            width="96"
            height="94"
          >
            <path
              d="M79.1142 113.477C105.434 113.477 126.771 92.7545 126.771 67.1924C126.771 41.6302 105.434 20.908 79.1142 20.908C52.7939 20.908 31.457 41.6302 31.457 67.1924C31.457 92.7545 52.7939 113.477 79.1142 113.477Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_766_23089)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M63.4051 55.0941H48.1427C45.6179 55.0941 43.5713 57.0818 43.5713 59.5338V119.026C43.5713 121.479 45.6179 123.466 48.1427 123.466H110.314C112.839 123.466 114.886 121.479 114.886 119.026V59.5338C114.886 57.0818 112.839 55.0941 110.314 55.0941H94.366C94.4815 55.5567 94.5427 56.04 94.5427 56.537C94.5427 59.9085 91.7285 62.6417 88.257 62.6417H69.5141C66.0426 62.6417 63.2284 59.9085 63.2284 56.537C63.2284 56.04 63.2897 55.5567 63.4051 55.0941Z"
              fill="url(#paint1_linear_766_23089)"
            />
          </g>
          <mask
            id="mask2_766_23089"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="31"
            y="20"
            width="96"
            height="94"
          >
            <path
              d="M79.1142 113.477C105.434 113.477 126.771 92.7545 126.771 67.1924C126.771 41.6302 105.434 20.908 79.1142 20.908C52.7939 20.908 31.457 41.6302 31.457 67.1924C31.457 92.7545 52.7939 113.477 79.1142 113.477Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask2_766_23089)">
            <path
              d="M99.1139 69.3013H58.8853C57.623 69.3013 56.5996 70.2951 56.5996 71.5211V76.6269C56.5996 77.8529 57.623 78.8467 58.8853 78.8467H99.1139C100.376 78.8467 101.4 77.8529 101.4 76.6269V71.5211C101.4 70.2951 100.376 69.3013 99.1139 69.3013Z"
              fill="white"
            />
          </g>
          <mask
            id="mask3_766_23089"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="31"
            y="20"
            width="96"
            height="94"
          >
            <path
              d="M79.1142 113.477C105.434 113.477 126.771 92.7545 126.771 67.1924C126.771 41.6302 105.434 20.908 79.1142 20.908C52.7939 20.908 31.457 41.6302 31.457 67.1924C31.457 92.7545 52.7939 113.477 79.1142 113.477Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask3_766_23089)">
            <path
              d="M93.171 87.2822H62.0853C61.3279 87.2822 60.7139 87.8785 60.7139 88.6142C60.7139 89.3498 61.3279 89.9461 62.0853 89.9461H93.171C93.9284 89.9461 94.5424 89.3498 94.5424 88.6142C94.5424 87.8785 93.9284 87.2822 93.171 87.2822Z"
              fill="white"
            />
            <path
              d="M57.971 89.9461C58.7285 89.9461 59.3425 89.3498 59.3425 88.6142C59.3425 87.8785 58.7285 87.2822 57.971 87.2822C57.2136 87.2822 56.5996 87.8785 56.5996 88.6142C56.5996 89.3498 57.2136 89.9461 57.971 89.9461Z"
              fill="white"
            />
          </g>
          <mask
            id="mask4_766_23089"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="31"
            y="20"
            width="96"
            height="94"
          >
            <path
              d="M79.1142 113.477C105.434 113.477 126.771 92.7545 126.771 67.1924C126.771 41.6302 105.434 20.908 79.1142 20.908C52.7939 20.908 31.457 41.6302 31.457 67.1924C31.457 92.7545 52.7939 113.477 79.1142 113.477Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask4_766_23089)">
            <path
              d="M82.6567 98.3816H62.0853C61.3279 98.3816 60.7139 98.9779 60.7139 99.7135C60.7139 100.449 61.3279 101.045 62.0853 101.045H82.6567C83.4141 101.045 84.0282 100.449 84.0282 99.7135C84.0282 98.9779 83.4141 98.3816 82.6567 98.3816Z"
              fill="white"
            />
            <path
              d="M57.971 101.045C58.7285 101.045 59.3425 100.449 59.3425 99.7135C59.3425 98.9779 58.7285 98.3816 57.971 98.3816C57.2136 98.3816 56.5996 98.9779 56.5996 99.7135C56.5996 100.449 57.2136 101.045 57.971 101.045Z"
              fill="white"
            />
          </g>
          <mask
            id="mask5_766_23089"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="31"
            y="20"
            width="96"
            height="94"
          >
            <path
              d="M79.1142 113.477C105.434 113.477 126.771 92.7545 126.771 67.1924C126.771 41.6302 105.434 20.908 79.1142 20.908C52.7939 20.908 31.457 41.6302 31.457 67.1924C31.457 92.7545 52.7939 113.477 79.1142 113.477Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask5_766_23089)">
            <path
              d="M96.1425 39.111C98.2886 39.111 100.028 37.4214 100.028 35.3372C100.028 33.253 98.2886 31.5634 96.1425 31.5634C93.9965 31.5634 92.2568 33.253 92.2568 35.3372C92.2568 37.4214 93.9965 39.111 96.1425 39.111Z"
              fill="url(#paint2_linear_766_23089)"
            />
          </g>
          <mask
            id="mask6_766_23089"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="31"
            y="20"
            width="96"
            height="94"
          >
            <path
              d="M79.1142 113.477C105.434 113.477 126.771 92.7545 126.771 67.1924C126.771 41.6302 105.434 20.908 79.1142 20.908C52.7939 20.908 31.457 41.6302 31.457 67.1924C31.457 92.7545 52.7939 113.477 79.1142 113.477Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask6_766_23089)">
            <path
              d="M52.7137 43.4398C52.7137 44.7271 53.7882 45.7706 55.1137 45.7706C56.4392 45.7706 57.5137 44.7271 57.5137 43.4398C57.5137 42.1525 56.4392 41.1089 55.1137 41.1089C53.7882 41.1089 52.7137 42.1525 52.7137 43.4398Z"
              fill="url(#paint3_linear_766_23089)"
            />
          </g>
          <mask
            id="mask7_766_23089"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="31"
            y="20"
            width="96"
            height="94"
          >
            <path
              d="M79.1142 113.477C105.434 113.477 126.771 92.7545 126.771 67.1924C126.771 41.6302 105.434 20.908 79.1142 20.908C52.7939 20.908 31.457 41.6302 31.457 67.1924C31.457 92.7545 52.7939 113.477 79.1142 113.477Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask7_766_23089)">
            <path
              d="M107.8 49.8774C107.8 51.1647 108.874 52.2082 110.2 52.2082C111.525 52.2082 112.6 51.1647 112.6 49.8774C112.6 48.5901 111.525 47.5465 110.2 47.5465C108.874 47.5465 107.8 48.5901 107.8 49.8774Z"
              fill="url(#paint4_linear_766_23089)"
            />
          </g>
          <g filter="url(#filter1_f_766_23089)">
            <path
              d="M124.6 52.8742C130.722 52.8742 135.686 48.0539 135.686 42.1078C135.686 36.1617 130.722 31.3414 124.6 31.3414C118.477 31.3414 113.514 36.1617 113.514 42.1078C113.514 48.0539 118.477 52.8742 124.6 52.8742Z"
              fill="#FF7070"
              fillOpacity="0.7"
            />
          </g>
          <path
            d="M121.852 50.8488C127.974 50.8488 132.938 46.0285 132.938 40.0824C132.938 34.1363 127.974 29.316 121.852 29.316C115.729 29.316 110.766 34.1363 110.766 40.0824C110.766 46.0285 115.729 50.8488 121.852 50.8488Z"
            fill="url(#paint5_linear_766_23089)"
          />
          <path
            d="M60.6014 135.073V135.997L58.9694 136.141V136.981H57.9134V136.225C57.1574 136.273 56.3774 136.333 55.5614 136.381L55.4294 135.397C56.3054 135.361 57.1334 135.325 57.9134 135.277V134.509H55.8134L55.5734 133.585C55.8494 133.273 56.1134 132.889 56.3774 132.433H55.2494V131.425H56.8574C56.9534 131.185 57.0374 130.945 57.1334 130.705L58.2614 130.885C58.1894 131.065 58.1294 131.245 58.0574 131.425H60.8294V132.433H57.5894C57.3734 132.841 57.1334 133.225 56.8934 133.573H57.9134V132.865H58.9694V133.573H60.7214V134.509H58.9694V135.205C59.5454 135.157 60.0854 135.121 60.6014 135.073ZM62.4134 134.521C62.2694 135.493 61.9334 136.345 61.4294 137.089L60.6374 136.261C61.1414 135.517 61.4174 134.629 61.4414 133.609V131.629C63.0014 131.485 64.1774 131.221 64.9694 130.849L65.7134 131.689C64.8374 132.073 63.7574 132.349 62.4854 132.493V133.525H65.9534V134.521H64.8014V136.993H63.7094V134.521H62.4134ZM64.7294 137.257V141.889H63.5774V141.469H57.7454V141.889H56.5934V137.257H64.7294ZM57.7454 140.497H63.5774V139.789H57.7454V140.497ZM57.7454 138.889H63.5774V138.205H57.7454V138.889ZM68.1254 131.353H76.8614V132.469H72.6374V133.189C72.6134 133.861 72.5654 134.485 72.4934 135.085H77.8094V136.189H74.1854V140.041C74.1854 140.425 74.3654 140.629 74.7374 140.629H76.0934C76.3334 140.629 76.5134 140.545 76.6334 140.377C76.7654 140.209 76.8614 139.657 76.9094 138.745L77.9774 139.093C77.8814 140.353 77.6894 141.109 77.4254 141.349C77.1854 141.577 76.8134 141.697 76.3094 141.697H74.3894C73.5014 141.697 73.0574 141.217 73.0574 140.281V136.189H72.3134C72.0974 137.221 71.7974 138.109 71.4014 138.865C70.6574 140.173 69.4574 141.181 67.8014 141.889L67.1654 140.869C68.8214 140.113 69.9374 139.153 70.5254 138.001C70.7774 137.449 70.9814 136.849 71.1254 136.189H67.3454V135.085H71.3294C71.4014 134.485 71.4494 133.861 71.4734 133.189V132.469H68.1254V131.353ZM84.5894 136.057C84.0854 137.305 83.1974 138.349 81.9134 139.213L81.1454 138.289C82.4414 137.401 83.2934 136.309 83.7014 135.013C83.8094 134.629 83.9054 134.209 83.9774 133.753H80.8934V141.877H79.7414V132.649H84.1094C84.1574 132.061 84.1934 131.437 84.1934 130.777H85.3574C85.3574 131.437 85.3334 132.061 85.2854 132.649H89.4374V140.389C89.4374 141.289 89.0174 141.745 88.1894 141.745H86.3054L85.9934 140.605L87.8054 140.665C88.1174 140.665 88.2854 140.485 88.2854 140.137V133.753H85.1654C85.0934 134.173 85.0214 134.569 84.9374 134.929C86.1374 136.033 87.1454 137.125 87.9734 138.217L87.0974 139.093C86.4734 138.145 85.6334 137.137 84.5894 136.057ZM96.8894 130.753C97.0094 131.053 97.1294 131.389 97.2494 131.749H101.629V134.029H100.525V132.793H92.6534V134.089H91.5494V131.749H96.0494C95.9294 131.461 95.7974 131.197 95.6534 130.945L96.8894 130.753ZM96.1814 134.593H97.0214C97.9934 135.769 99.6734 136.789 102.049 137.677L101.437 138.601C101.029 138.433 100.645 138.277 100.297 138.121V141.901H99.2054V141.469H94.1054V141.901H93.0014V138.073C92.5934 138.265 92.1614 138.433 91.7294 138.601L91.1174 137.677C93.3014 136.885 94.9934 135.865 96.1814 134.593ZM94.1054 140.437H99.2054V138.769H94.1054V140.437ZM93.6254 137.761H99.5414C98.2934 137.113 97.3214 136.381 96.6014 135.565C95.7494 136.429 94.7534 137.161 93.6254 137.761ZM98.0894 133.105C99.5294 133.849 100.753 134.593 101.737 135.325L100.945 136.105C100.093 135.397 98.8934 134.629 97.3574 133.813L98.0894 133.105ZM95.0654 133.105L95.8094 133.777C94.7894 134.677 93.5414 135.469 92.0534 136.141L91.3694 135.253C92.8334 134.641 94.0574 133.921 95.0654 133.105Z"
            fill="black"
          />
          <path
            d="M121.607 35.0881C122.517 35.0881 123.245 35.3261 123.805 35.8301C124.351 36.3201 124.631 36.9921 124.631 37.8321C124.631 38.5181 124.449 39.0921 124.113 39.5401C123.987 39.6941 123.595 40.0581 122.923 40.6321C122.671 40.8561 122.475 41.0941 122.349 41.3461C122.195 41.6261 122.125 41.9341 122.125 42.2841V42.5221H120.627V42.2841C120.627 41.7661 120.711 41.3181 120.893 40.9541C121.089 40.5621 121.621 39.9881 122.489 39.2181L122.727 38.9521C122.979 38.6301 123.105 38.2941 123.105 37.9301C123.105 37.4401 122.965 37.0621 122.699 36.7821C122.419 36.5021 122.027 36.3621 121.523 36.3621C120.893 36.3621 120.431 36.5581 120.151 36.9501C119.899 37.2861 119.773 37.7761 119.773 38.3921H118.289C118.289 37.3701 118.583 36.5721 119.185 35.9841C119.773 35.3821 120.585 35.0881 121.607 35.0881ZM121.369 43.2781C121.663 43.2781 121.915 43.3621 122.111 43.5581C122.307 43.7401 122.405 43.9781 122.405 44.2721C122.405 44.5661 122.307 44.8041 122.111 45.0001C121.901 45.1821 121.649 45.2801 121.369 45.2801C121.075 45.2801 120.837 45.1821 120.655 44.9861C120.445 44.7901 120.347 44.5521 120.347 44.2721C120.347 43.9781 120.445 43.7401 120.655 43.5581C120.837 43.3621 121.075 43.2781 121.369 43.2781Z"
            fill="white"
          />
        </g>
        <defs>
          <filter
            id="filter0_f_766_23089"
            x="0.347462"
            y="-10.3004"
            width="157.534"
            height="154.986"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="17.2691" result="effect1_foregroundBlur_766_23089" />
          </filter>
          <filter
            id="filter1_f_766_23089"
            x="104.304"
            y="22.1312"
            width="40.5918"
            height="39.9532"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="4.6051" result="effect1_foregroundBlur_766_23089" />
          </filter>
          <linearGradient
            id="paint0_linear_766_23089"
            x1="78.8856"
            y1="42.2188"
            x2="78.8856"
            y2="60.5372"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#0047FF" />
            <stop offset="1" stopColor="#F5F8FF" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_766_23089"
            x1="49.057"
            y1="60.1998"
            x2="91.3864"
            y2="134.756"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#CFDCFF" />
            <stop offset="1" stopColor="#0047FF" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_766_23089"
            x1="96.1425"
            y1="31.5634"
            x2="96.1425"
            y2="39.111"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B0BCFF" />
            <stop offset="1" stopColor="#B0BCFF" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_766_23089"
            x1="52.7137"
            y1="43.4398"
            x2="57.5137"
            y2="43.4398"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B0BCFF" />
            <stop offset="1" stopColor="#B0BCFF" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_766_23089"
            x1="107.8"
            y1="49.8774"
            x2="112.6"
            y2="49.8774"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B0BCFF" stopOpacity="0.53" />
            <stop offset="1" stopColor="#B0BCFF" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id="paint5_linear_766_23089"
            x1="121.852"
            y1="29.316"
            x2="121.852"
            y2="50.8488"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF9898" />
            <stop offset="1" stopColor="#FF4F4F" />
          </linearGradient>
          <clipPath id="clip0_766_23089">
            <rect width="160" height="160" fill="white" transform="translate(0 0.5)" />
          </clipPath>
        </defs>
      </svg>
    </div>
  )
}

export default EmptySmall
